import firebase from '../../lib/firebase.prod';
import * as PROJECT_CODE from '../../constants/projectCode';
import * as DOCUMENT_NAME from '../../constants/documentNames';

const firebaseRef = firebase.database();

export default function getAuditTrailInformation(leadId, documentName) {
	var document;
	firebaseRef
		.ref('/kavtek_agreements/' + PROJECT_CODE.projectCode + '/' + leadId)
		.once('value', (snapshot) => {
			try {
				var signatureRequestsObj;

				console.log(
					'getAuditTrailInformation documentName',
					documentName
				);

				if (
					documentName === DOCUMENT_NAME.aps ||
					documentName === DOCUMENT_NAME.condo_docs
				) {
					console.log('getAuditTrailInformation in the if');
					signatureRequestsObj =
						snapshot.val()?.documentInformation?.signatureRequests;
				} else {
					console.log('getAuditTrailInformation in the else');
					signatureRequestsObj =
						snapshot.val()?.documentInformation
							?.signatureRequestsExtras;
				}

				console.log(
					'getAuditTrailInformation signatureRequestsObj',
					signatureRequestsObj
				);

				//start to search for document name
				var signatureRequestsObjKeys =
					signatureRequestsObj && Object?.keys(signatureRequestsObj);

				//this will be the key that will get the parent of the searched document name
				var keyNeeded = [];

				//looping through to get the subject key
				signatureRequestsObjKeys?.forEach((key) => {
					var subjectName =
						signatureRequestsObj &&
						signatureRequestsObj[key]['subject'];

					console.log(
						'getAuditTrailInformation subjectName',
						subjectName
					);

					if (subjectName === documentName) {
						keyNeeded.push(key);
					}
				});

				var timestamps = [];

				keyNeeded.forEach((key) => {
					//parent needed obj key
					var documentObj = signatureRequestsObj?.[key];

					console.log(
						'getAuditTrailInformation documentObj',
						documentObj
					);

					document = {
						documentName: documentObj['subject'],
						timestamps: [],
					};

					var signatureUpdatesObj = documentObj['signatureUpdates'];

					console.log(
						'getAuditTrailInformation signatureUpdatesObj',
						signatureUpdatesObj
					);

					//get the signature updates keys
					var signatureUpdatesKeys =
						Object?.keys(signatureUpdatesObj);
					console.log(
						'getAuditTrailInformation signatureUpdatesKeys',
						signatureUpdatesKeys
					);

					signatureUpdatesKeys.forEach((key) => {
						var latestSignature;
						var eventObj = signatureUpdatesObj[key]['event'];
						var eventTimestamp = eventObj['event_time'];
						var eventType = eventObj['event_type'];

						var signatureRequestObj =
							signatureUpdatesObj[key]['signature_request'];

						var firstPointRequestEmail =
							signatureRequestObj['requester_email_address'];

						//getting the signature object
						var signaturesObj = signatureRequestObj['signatures'];

						//getting the signature keys
						var signaturesObjKeys =
							signaturesObj && Object.keys(signaturesObj);

						var newSignatureArr = [];

						if (eventType === 'signature_request_canceled') {
							document.timestamps.push({
								timestamp: eventTimestamp,
								type: eventType,
							});
						}

						signaturesObjKeys?.forEach((key) => {
							var signerEmailAddress =
								signaturesObj[key]['signer_email_address'];

							var signerName = signaturesObj[key]['signer_name'];
							var signerRole = signaturesObj[key]['signer_role'];
							var statusCode = signaturesObj[key]['status_code'];

							var newSigObj = {
								signerEmailAddress: signerEmailAddress,
								signerName: signerName,
								signerRole: signerRole,
								statusCode: statusCode,
							};

							console.log(
								'getAuditTrailInformation newSigObj',
								newSigObj
							);

							newSignatureArr.push(newSigObj);
						});

						console.log(
							'getAuditTrailInformation newSignatureArr',
							newSignatureArr
						);

						//manipulate signature to get the latest one
						if (eventType === 'signature_request_signed') {
							var signedArray = [];
							newSignatureArr.forEach((key) => {
								console.log('newSignatureArr[key]', key);
								var statusCode = key['statusCode'];

								if (statusCode === 'signed') {
									signedArray.push(key);
								}
							});

							latestSignature =
								signedArray[signedArray.length - 1];
						} else if (eventType === 'signature_request_canceled') {
							latestSignature = [];
						}

						if (eventType === 'signature_request_sent') {
							var signedArray = [];
							newSignatureArr.forEach((key) => {
								signedArray.push(key);
							});

							//latestSignature = signedArray[0];
							signedArray.forEach((item) => {
								if (item) {
									timestamps.push({
										timestamp: eventTimestamp,
										type: eventType,
										signatures: item,
									});
								}
							});
						} else {
							console.log('latestSignature', latestSignature);

							var timestampObj = {
								timestamp: eventTimestamp,
								type: eventType,
								signatures: latestSignature,
							};

							console.log(
								'getAuditTrailInformation timestampObj',
								timestampObj
							);

							if (timestampObj.signatures !== undefined) {
								console.log(
									'timestampObjtimestampObjtimestampObj',
									timestampObj
								);
								timestamps.push(timestampObj);
							}
						}
					});
				});
				document['timestamps'] = timestamps && timestamps;
			} catch (error) {
				console.error(error);
			}
		});

	console.log('timestampstimestamps', document);
	return document;
}
